import usePermissions from "app/hooks/usePermissions";
import { PERMISSIONS } from "app/utils/permissions";
import { Navigate } from "react-router-dom";

const DefaultRedirect = () => {
  const { hasPermission } = usePermissions();

  return hasPermission(PERMISSIONS.Dashboard.Menu) ? (
    <Navigate to="/dashboard/default" replace />
  ) : (
    <Navigate to="/profile" replace />
  );
};

export default DefaultRedirect;
